export const createModalDraftSeedTracker = () => ({
  wasOpen: false,
  lastSeedKey: "",
});

/**
 * Re-seed a modal draft only when it opens or the logical item changes.
 * Parent re-renders that only change object identity must not wipe in-progress input.
 */
export const shouldSeedModalDraft = (tracker, { isOpen, seedKey } = {}) => {
  if (!tracker) return Boolean(isOpen);

  if (!isOpen) {
    tracker.wasOpen = false;
    tracker.lastSeedKey = "";
    return false;
  }

  const nextSeedKey = String(seedKey ?? "");
  const justOpened = !tracker.wasOpen;
  tracker.wasOpen = true;
  if (!justOpened && tracker.lastSeedKey === nextSeedKey) {
    return false;
  }

  tracker.lastSeedKey = nextSeedKey;
  return true;
};
